export default {
    SET_GESTIONES: (state, gestion) => {
        state.gestiones = gestion
    },
    SET_MANAGEMENT_SELECTED: (state, payload) => {
        state.managementSelected = payload
    },
    SET_USERS_MANAGEMENTS_ROLES: (state, payload) => {
        state.usersManagementsRoles = payload
    },
    SET_USERS_MANAGEMENTS_ROLES_FILTERED: (state, payload) => {
        state.usersManagementsRolesFiltered = payload
    }
}